import { ComponentStyleConfig } from "@chakra-ui/react";

export const Header: ComponentStyleConfig = {
  baseStyle: {
    padding: "10px",
    bgColor: "brand.green",
  },
};
